module.exports = __webpack_public_path__ + "img/huailai01.aea099ff.png";